import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";
import tokenService from '../../Common/tokenDecoder';

export default {
    saveTask,
    editTask,
    getGroups,
    getEstatesByGroupID,
    getAllByFilter,
    getTaskTypes,
    getAllTaskNames,
    GetAllOperationEntityByGroupID,
    getRates,
    GetEmployeeTypesData,
    deleteRates,
    saveRates
};

async function saveTask(data, ratesList) {
    const formData = {
        estateTaskID: parseInt(data.estateTaskID),
        operationEntityId: parseInt(data.operationEntityID),
        taskCode: data.taskCode,
        taskName: data.taskName,
        taskDescription: data.taskDescription,
        measuringUnit: data.measuringUnit,
        budgetexpensescode: data.budgetexpensescode,
        rateList: ratesList,
        createdBy: data.createdBy,
        isActive: data.isActive,
        isRate: data.isRate
    }
    var result = await CommonPost('/api/EstateTask/SaveLabourTask', null, formData);
    return result;
}

async function editTask(data, editRates) {
    const formData = {
        taskID: data.taskID,
        estateTaskID: parseInt(data.estateTaskID),
        operationEntityId: parseInt(data.operationEntityID),
        taskCode: data.taskCode,
        taskName: data.taskName,
        taskDescription: data.taskDescription,
        measuringUnit: data.measuringUnit,
        budgetexpensescode: data.budgetexpensescode,
        updateRateList: editRates,
        modifiedBy: parseInt(tokenService.getUserIDFromToken()),
        isActive: data.isActive,
        isRate: data.isRate

    }
    var result = await CommonPost('/api/EstateTask/UpdateLabourTask', null, formData);
    return result;

}

async function getAllByFilter(operationEntityId) {
    var response = await CommonGet('/api/EstateTask/GetLabourTaskByFilter', 'operationEntityID=' + operationEntityId);
    return response.data;
}


async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getRates(taskID) {
    var response = await CommonGet('/api/EstateTask/GetLabourTaskByTaskID', 'taskID=' + parseInt(taskID));
    return response.data;
}

async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstates', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["groupID"] == groupID) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}

async function GetEmployeeTypesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeTypeEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}


async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}


async function getTaskTypes() {
    var response = await CommonGet('/api/EnumData/GetTaskTypeEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}
async function getAllTaskNames(groupID, operationEntityID) {
    const response = await CommonGet('/api/EstateTask/GetEstateTaskByFilter', 'groupID=' + groupID + '&operationEntityID=' + operationEntityID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            array[item[1]["estateTaskId"]] = item[1]["estateTaskName"]
        }
    }
    return array;
}

async function deleteRates(employeeTaskTemplateRateID, taskID) {
    var response = await CommonGet('/api/EstateTask/DeleteLabourTaskRate', 'employeeTaskTemplateRateID=' + parseInt(employeeTaskTemplateRateID) + '&taskID=' + parseInt(taskID));
    return response;
}

async function saveRates(taskID) {
    var response = await CommonGet('/api/EstateTask/GetLabourTaskByTaskID', 'taskID=' + parseInt(taskID));
    return response.data;
}

